import React, { useState, useEffect } from 'react';
import { DirtyWarningContext, DirtyWarningContextShape } from './DirtyWarningContext';
import { DirtyWarningPrompt, DirtyWarningPromptProps } from './DirtyWarningPrompt';

export interface DirtyWarningProviderProps {
    dirty?: boolean    
 }

export const DirtyWarningProvider: React.FC<DirtyWarningProviderProps> = (props) => {    
    const dirtyValue = props.dirty || false; 
    const defaultPromptOptions: DirtyWarningPromptProps = {
        show: false,
        onConfirm: () => {}
    }

    const [dirty, setDirty] = useState(dirtyValue);
    const [promptOptions, setPromptOptions] = useState(defaultPromptOptions);
    
    const confirmUnsavedChanges = (message?: string) : Promise<boolean> => {
        return new Promise((resolve) => {
            setPromptOptions({
                show: true,
                message: message,
                onConfirm: () => {
                    setPromptOptions(defaultPromptOptions);
                    resolve(true);
                },
                onCancel: () => {
                    setPromptOptions(defaultPromptOptions);
                    resolve(false);
                }
            });                
        });
    }

    const dirtyWarning : DirtyWarningContextShape = {
        dirty: dirty,        
        setDirty: setDirty,        
        confirm: confirmUnsavedChanges
    };

    // Effect
    useEffect(() => {
        setDirty(dirtyValue);
    }, [dirtyValue]); 

    return (        
        <DirtyWarningContext.Provider value={dirtyWarning}>            
            <DirtyWarningPrompt {...promptOptions}></DirtyWarningPrompt>
            {props.children}
        </DirtyWarningContext.Provider>
    )    
}